export default __webpack_public_path__ + "static/media/innovation.1abd9fa7.jpg";